import { isCommercial, offerTypeFromJsonQuery } from '../../../../JsonQuery';
import { createRangeTagManager } from '../../utils/createRangeTagManager';

export const totalFloorsTagManager = createRangeTagManager({
  jsonQueryKey: 'floorn',
  template: 'Этажей в доме %s',
  id: 'totalFloors',
  isApplicable: jsonQuery => !isCommercial(offerTypeFromJsonQuery(jsonQuery)),
});
